import { MessageSquare, Bot, TrendingDown } from 'lucide-react';
import { Card } from '@/components/ui/card';

export const WhyHirerkeySection = () => {
  const reasons = [
    {
      icon: MessageSquare,
      title: 'Built on Real Conversations',
      description: 'We didn’t guess what HR professionals need—we asked. Over 100 professionals shaped how hirerkey™ thinks, acts, and solves real workplace problems.',
      highlight: 'Insight-Driven',
      gradient: 'from-purple-500/10 to-purple-600/5',
    },
    {
      icon: Bot,
      title: 'AI That Works Quietly Behind the Scenes',
      description: 'No buzzwords, just results. From onboarding to payroll, AI handles repetitive tasks so your team can focus on people, not paperwork.',
      highlight: 'Smart Automation',
      gradient: 'from-blue-500/10 to-blue-600/5',
    },
    {
      icon: TrendingDown,
      title: 'Priced for Impact, Not Prestige',
      description: 'We believe technology should empower, not exclude. hirerkey™ gives you enterprise-grade tools at prices 75% lower than traditional systems.',
      highlight: 'Value-Focused',
      gradient: 'from-pink-500/10 to-pink-600/5',
    },
  ];

  return (
    <section className="py-8 sm:py-10 md:py-12">
      <div className="max-w-[745px] w-full mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10 animate-fade-in">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4 text-gradient-primary">
            Don't Think Why—Simply Choose hirerkey<sup className="text-base sm:text-lg">™</sup>
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
            <span className="emphasize font-semibold text-foreground">More than 20 reasons</span> to adopt hirerkey<sup>™</sup>; let's review the top 3....
          </p>
        </div>

        {/* Reasons Grid - Single Column */}
        <div className="space-y-6 sm:space-y-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <Card
                key={index}
                className={`relative p-5 sm:p-6 hover-lift bg-gradient-to-br ${reason.gradient} backdrop-blur-sm border-2 border-primary/10 hover:border-primary/30 transition-all overflow-hidden animate-fade-in`}
                style={{ animationDelay: `${index * 0.1}s`, marginBottom: '15px' }}
              >
                <div className="relative">
                  {/* Chip in top-right corner */}
                  <div className="absolute top-0 right-0 inline-block px-3 py-1.5 rounded-full bg-[goldenrod] text-[ghostwhite] text-xs font-semibold border border-[goldenrod]">
                    {reason.highlight}
                  </div>
                  
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center mb-3 sm:mb-4">
                    <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-primary" />
                  </div>
                  
                  <h3 className="text-base sm:text-lg font-bold mb-2 sm:mb-3 text-foreground pr-24">
                    {reason.title === 'Enterprise Value, Startup Agility' ? (
                      <>Enterprise Value, Startup Agility</>
                    ) : reason.title === 'Rapid Workplace Implementation' ? (
                      <>Rapid Workplace <span className="emphasize-accent">Change</span></>
                    ) : (
                      reason.title
                    )}
                  </h3>
                  <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyHirerkeySection;
